import { BRACKET_STAGE_PADDING, getBracketStageLayout } from './stage'
import type { BracketBackgroundPosition, BracketBox, PanOffset } from './types'

export type BracketVisibleArea = {
  left: number
  top: number
  width: number
  height: number
}

export function getBracketVisibleArea({
  bracketWidth,
  bracketHeight,
  viewportWidth,
  viewportHeight,
  zoom,
  pan,
  position,
}: {
  bracketWidth: number
  bracketHeight: number
  viewportWidth: number
  viewportHeight: number
  zoom: number
  pan: PanOffset
  position: BracketBackgroundPosition
}): BracketVisibleArea {
  const { stageWidth, stageHeight } = getBracketStageLayout({
    bracketWidth,
    bracketHeight,
    viewportWidth,
    viewportHeight,
    zoom,
  })
  const left = Math.max(BRACKET_STAGE_PADDING, (stageWidth - bracketWidth) / 2)
  const top =
    position === 'top'
      ? BRACKET_STAGE_PADDING
      : position === 'bottom'
        ? Math.max(
            BRACKET_STAGE_PADDING,
            stageHeight - bracketHeight - BRACKET_STAGE_PADDING,
          )
        : Math.max(BRACKET_STAGE_PADDING, (stageHeight - bracketHeight) / 2)
  return {
    left: -pan.x / zoom - left,
    top: -pan.y / zoom - top,
    width: viewportWidth / zoom,
    height: viewportHeight / zoom,
  }
}

export function isBracketBoxVisible(
  box: BracketBox,
  area: BracketVisibleArea | null,
): boolean {
  // 留出缓冲区，避免拖拽时边缘卡片和外侧队名闪烁；输出模式传 null。
  const overscan = 160
  return (
    !area ||
    (box.left + box.width >= area.left - overscan &&
      box.left <= area.left + area.width + overscan &&
      box.top + box.height >= area.top - overscan &&
      box.top <= area.top + area.height + overscan)
  )
}
